<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar></navbar>
			<!--导航-->
			<!--块1-->
			<div v-if="infoData" class="block_1">
				<div class="block_1_box">
					<div class="block_1_main"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="left">
							<!--引导块-->
							<div class="tips_box">
								<span>Home&nbsp;&nbsp;>&nbsp;&nbsp;Products&nbsp;&nbsp;>&nbsp;&nbsp;{{ infoData.parent_name }}&nbsp;&nbsp;>&nbsp;&nbsp;</span>{{ infoData.title }}
							</div>
							<!--引导块-->
							<div class="tit">{{ infoData.title }}</div>
							<div class="txt" v-html="infoData.content"></div>
							<div v-if="infoData.cert_image.length > 0" class="rz_box"
								data-aos="fade-in"
								data-aos-duration="400"
								data-aos-delay="100"
								data-aos-offset="0"
								data-aos-once="true"
							>
								<div v-for="(value, index) in infoData.cert_image" :key="index">
									<img :src="value.image" />
								</div>
							</div>
							<div class="btn_box_more"
								data-aos="fade-in"
								data-aos-duration="400"
								data-aos-delay="100"
								data-aos-offset="0"
								data-aos-once="true"
								@click="goContact"
							>
								Request Information<img src="../../assets/img/组 32@2x.png" />
							</div>
							<div v-if="infoData.buy_url" class="btn_box_more2"
								data-aos="fade-in"
								data-aos-duration="400"
								data-aos-delay="100"
								data-aos-offset="0"
								data-aos-once="true"
								@click="goBuyUrl"
							>
								<img src="../../assets/img/20230923.png" />Buy Now
							</div>
						</div>
						<div class="right">
							<img :src="infoData.url" />
						</div>
					</div>
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<template v-if="infoData">
				<div v-if="infoData.tags.length > 0" class="block_2"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="list_box">
						<div v-for="(value, index) in infoData.tags" :key="index"
							class="list_el"
							:class="nowList == value.id ? 'actived' : ''"
							@click="listClick(value)"
						>{{ value.catname }}</div>
					</div>
					<div class="content" v-html="nowContent"></div>
				</div>
			</template>
			<!--块2-->
			<!--块3-->
			<template v-if="infoData">
				<div v-if="infoData.videos.length > 0" class="block_3"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div v-for="(value, index) in infoData.videos" :key="index" class="block_3_el">
						<div class="tit">{{ value.catname }}</div>
						<div class="video_box">
							<iframe
								width="846"
								height="476"
								:src="value.url"
								title="YouTube video player"
								frameborder="0"
								allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
								allowfullscreen
							></iframe>
						</div>
						<div class="content">
							<div class="content_main" v-html="value.content"></div>
						</div>
					</div>
				</div>
				<div v-else style="padding-bottom: 80px;"></div>
			</template>
			<!--块3-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import fixed from '@/component/pc/fixed.vue'  //联系我们悬浮
import { productInfo, productCount  } from '@/api/public';
import md5 from 'js-md5';
import moment from 'moment';
export default {
	components:{
		navbar,
		footerBox,
		fixed,
	},
	metaInfo() {
		return {
			meta: [
				{
					name: "description",
					content: this.metaDescription,
				},{
					name: "keywords",
					content: this.metaKeywords,
				}
			]
		}
	},
	data() {
		return {
			isLoading: true,  //界面loading
			infoData: null,
			nowList: null,
			nowContent: '',
			metaDescription: '',
			metaKeywords: '',
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
		//请求产品信息
		productInfo({
			custom: that.$route.params.productInfoId,
		}).then(res => {
			if (that._isDestroyed) return;
			that.infoData = res.data;
			document.title = res.data.title + ' - CorDx';
			that.metaDescription = res.data.description;
			that.metaKeywords = res.data.keywords;
			//设置OG标签
			that.setOgTag('og:locale', 'en_US');
			that.setOgTag('og:title', res.data.title);
			that.setOgTag('og:description', res.data.description);
			that.setOgTag('og:image', res.data.url);
			that.setOgTag('og:image:width', '1200');
			that.setOgTag('og:image:height', '630');
			that.setOgTag('og:image:type', 'webp');
			if(that.infoData.tags.length > 0) {
				that.nowList = that.infoData.tags[0].id;
				that.nowContent = that.infoData.tags[0].content;
			}
			that.isLoading = false;
			//统计访问
			let time = String(moment(new Date()).valueOf());
			that.visitTimer = setTimeout(() => {
				if (that._isDestroyed) return;
				productCount({
					language: sessionStorage.getItem('lang') == 'en' ? 2 : 1,
					cate_id: that.infoData.cate_id,
					cert_id: that.infoData.cert_id,
					productid: that.infoData.id,
					url: that.$route.name,
					addtime: time,
					sign: md5(String(that.infoData.cate_id) + String(that.infoData.cert_id) + String(that.infoData.id) + that.$route.name + String(time) + 'CorDx2023'),
				}).catch(() => {});
			}, 10000);
		}).catch(() => {
			if (!that._isDestroyed) that.isLoading = false;
		});
	},
	beforeDestroy() {
		clearTimeout(this.visitTimer);
	},
	mounted() {
		let that = this;
	},
	watch: {
		//
	},
	methods: {
		//设置OG标签
		setOgTag(property, content) {
			const meta = document.querySelector(`meta[property='${property}']`);
			if(meta) {
				meta.setAttribute('content', content);
			} else {
				const newMeta = document.createElement('meta');
				newMeta.setAttribute('property', property);
				newMeta.setAttribute('content', content);
				document.head.appendChild(newMeta);
			}
		},
		//底部列表点击
		listClick(value) {
			let that = this;
			that.nowList = value.id;
			that.nowContent = value.content;
		},
		//联系我们
		goContact() {
			this.$router.push({ path: '/contact', });
		},
		goBuyUrl() {
			let that = this;
			window.open(that.infoData.buy_url, '_blank');
		},
	}
}
</script>

<style scoped>
>>> .main_box ol,>>> .main_box ul{
	list-style: initial !important;
	margin: revert !important;
	padding: revert !important;
}
/* >>> .main_box h3 strong{
	font-size: 24px;
}
>>> .main_box h3 font{
	font-size: 24px;
}
>>> .main_box h5{
	font-size: 20px;
}
>>> .main_box h5 font{
	font-size: 20px;
}
>>> .main_box p{
	font-size: 18px;
}
>>> .main_box p font{
	font-size: 18px;
}
>>> .main_box li{
	font-size: 18px;
}
>>> .main_box li::before{
	content: '●';
	padding-right: 4px;
} */
</style>
<style lang="less" scoped>
.main_box{
	width: 100%;
	height: auto;
	/*块3*/
	.block_3{
		width: 1140px;
		margin: 0 auto;
		padding: 0px 0 30px 0;
		.block_3_el:last-child{
			.content{
				border: none;
			}
		}
		.block_3_el{
			padding-top: 70px;
			.content{
				padding: 70px 0;
				border-bottom: 1px solid #CBD6E2;
			}
			.tit{
				padding-bottom: 60px;
				text-align: center;
				font-size: 42px;
				color: #000000;
			}
			.video_box{
				text-align: center;
			}
		}
	}
	/*块2*/
	.block_2{
		width: 1140px;
		margin: 0 auto;
		padding: 70px 0 0px 0;
		.content{
			margin-top: 30px;
			padding: 0 30px;
			border: 1px solid #0B318F;
		}
		.list_box{
			.list_el{
				display: inline-block;
				margin: 10px 10px 0 0;
				padding: 12px 20px;
				font-size: 18px;
				background-color: #EFEFEF;
				color: #000000;
				cursor: pointer;
			}
			.list_el.actived{
				color: #ffffff;
				background-color: #0B318F;
			}
			.list_el:hover{
				color: #ffffff;
				background-color: #0066D4;
			}
		}
	}
	/*块1*/
	.block_1{
		width: 100%;
		padding: 60px 0;
		// background: linear-gradient(to right, #F2F7FD, transparent);
		background: url(../../assets/img/20230907-095539.png);
		background-size: 100%;
		.block_1_box{
			width: 1140px;
			margin: 0 auto;
			.block_1_main{
				display: flex;
				align-items: center;
				.left{
					flex: 1;
					padding-right: 30px;
					padding-top: 30px;
					padding-bottom: 30px;
					.rz_box{
						display: flex;
						align-items: center;
						padding: 20px 0 40px 0;
						div{
							width: 60px;
							margin-right: 30px;
							img{
								width: 100%;
							}
						}
					}
					.tips_box{
						padding: 0 0 50px 0;
						font-size: 16px;
						span{
							color: #0B318F;
						}
					}
					.txt{
						padding: 15px 0;
						font-size: 18px;
					}
					.tit{
						padding-bottom: 10px;
						font-size: 35px;
					}
				}
				.right{
					width: 450px;
					img{ width: 100%; }
				}
			}
		}
	}
	.btn_box_more2{
		position: relative;
		top: 1px;
		display: inline-block;
		margin-left: 30px;
		padding: 0 28px;
		height: 42px;
		line-height: 45px;
		font-size: 20px;
		color: #E35B00;
		background: #ffffff;
		border-radius: 22px 22px 22px 22px;
		border: 1px solid #E37900;
		text-align: center;
		cursor: pointer;
		img{
			width: 20px;
			position: relative;
			top: 10px;
			margin-right: 10px;
			transition: all 0.3s;
		}
	}
	.btn_box_more2:hover{
		background: rgba(227, 121, 0, 0.1);
	}
	.btn_box_more{
		display: inline-block;
		padding: 0 28px;
		height: 42px;
		line-height: 42px;
		font-size: 20px;
		color: #0B318F;
		background: #f5f8fa;
		border-radius: 22px 22px 22px 22px;
		border: 1px solid #0B318F;
		text-align: center;
		cursor: pointer;
		img{
			width: 20px;
			position: relative;
			top: 10px;
			left: 10px;
			transition: all 0.3s;
		}
	}
	.btn_box_more:hover{
		img{
			transform: translateX(6px);
		}
		background-color: #f5f8fa;
	}
}
</style>
